
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Action } from "vuex-class";
import { Prop } from "vue-property-decorator";
import { AxiosResponse } from "axios";
import toast from "@/functions/toast.function";

@Component({
  components: {
  },
  filters,
})
export default class ModalApproveExtend extends Vue {
  @Action("actionApprove", { namespace: "partnership" })
  private actionApprove: any;
  @Action("actionExtend", { namespace: "partnership" })
  private actionExtend: any;

  @Prop({default: false})
  private show: boolean;
  @Prop({default: false})
  private isExtend: boolean;
  @Prop({default: 0})
  private id: number;
  @Prop({default: 0})
  private tempId: number;

  private startDate: string = "";
  private endDate: string = "";
  private partnershipNumber: string = "";
  private agreement_doc: any = null;
  private agreement_doc_preview: string = "";
  private isCorrect: boolean = false;

  private reset() {
    this.startDate = "";
    this.endDate = "";
    this.partnershipNumber = "";
    this.agreement_doc = "";
    this.agreement_doc_preview = "";
    this.isCorrect = false;
    this.$emit("close");
  }

  private openFile () {
    document.getElementById("partnership-agreement").click();
  }
  private onAgreementChange (event: any) {
    const file = event.target.files[0];
    this.agreement_doc = file;
    this.agreement_doc_preview = file.name;
    const ref = this.$refs.agreementApproveRef as any;
    ref.value = "";
  }

  private submit() {
    if (!this.startDate) {
      toast.warning(this.$t("company_partnership_validate_start_date"));
      return;
    }
    if (!this.endDate) {
      toast.warning(this.$t("company_partnership_validate_end_date"));
      return;
    }
    if (!this.partnershipNumber) {
      toast.warning(this.$t("company_partnership_validate_partnership_number"));
      return;
    }
    if (!this.agreement_doc) {
      toast.warning(this.$t("company_partnership_validate_agreement_doc"));
      return;
    }
    if (!this.isCorrect) {
      toast.warning(this.$t("company_partnership_validate_is_correct"));
      return;
    }
    const formData = new FormData();
    formData.append("id", this.id.toString());
    formData.append("temp_id", this.tempId.toString());
    formData.append("start_date", this.startDate);
    formData.append("end_date", this.endDate);
    formData.append("partnership_number", this.partnershipNumber);
    formData.append("agreement_doc", this.agreement_doc);
    if (this.isExtend) {
      this.actionExtend({
        params: formData,
        success: (response: AxiosResponse) => {
          if (response) {
            toast.success("Extended.");
            this.$emit("submit");
          }
        },
      });
    } else {
      this.actionApprove({
        params: formData,
        success: (response: AxiosResponse) => {
          if (response) {
            toast.success("Approved.");
            this.$emit("submit");
          }
        },
      });
    }
  }
}
